import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../API';
import { useParams } from 'react-router-dom';
import { Button, Groupper, Header, Message, Modal, Placeholder, Table, Toast } from 'react-frontier';
import moment from 'moment';
import ReactJson from 'react-json-view';
import { bindClose } from '@payfront/components/Util';
import { SetLoading } from '../DashboardClasses';

interface WebhookResponseData{
	response_id: number,
	webhook_id: number,
	webhook_url: string,
	payment_id: number,
	event_id: number,
	date_created: number,
	date_try: number,
	date_response: number,
	response_status: number,
	response: {
		sent: any,
		response: any[]
	}
}

enum Modals{
	RESEND = 1,
}

var WebhookResponse = ()=>{
	var { t } = useTranslation();
	var params = useParams<{ response_id: string }>();
	var response_id = params && params.response_id && !Number.isNaN(parseInt(params.response_id)) ? parseInt(params.response_id) : null;
	var [data, setData] = useState<WebhookResponseData>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [shownModal, setShownModal] = useState<Modals>(null);

	useEffect(()=>{
		if(!response_id) return;
		getResponse();
	}, []);

	useEffect(()=>{
		setModalPrompts(null);
	}, [shownModal]);

	var getResponse = ()=>{
		API.getWebhookResponse(response_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setData(res.data);
		}).catch(err=>{
			setLoadError(t('common.unexpected_error', { code: 'LCL-WBHRP-1' }));
		})
	}

	var resendWebhook = (setLoading: SetLoading)=>{
		if(!data) return;
		setLoading(true);
		API.resendWebhook(data.response_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			if(!res.data.resent){
				return setModalPrompts([t('webhooks.error_resend')]);
			}else{
				setShownModal(null);
				setData(null);
				getResponse();
				Toast.success(t('webhooks.resent'))
			}
		}).catch(err=>{
			setModalPrompts([t('common.unexpected_error', { code: 'LCL-WBHRSND-1' })]);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var response_date = data ? (data.date_response || data.date_try || data.date_created) : null
	
	return <div className="pf webhook-response-screen" style={{ padding: 15 }}>
		<Groupper title={'Detalles'} width={450} titleRight={(
			<Button size='tiny' text={t('common.resend')} disabled={!data} onClick={bindClose(setShownModal, Modals.RESEND)} />
		)}>
			<Table fitted striped details
			 	className='last'
				data={[
					['ID', <Placeholder value={data?.response_id} width={30} />],
					[t('common.webhook'), <Placeholder value={data?.webhook_id} />],
					['URL', <Placeholder value={data?.webhook_url} />],
					[t('common.event'), <Placeholder value={data?.event_id ? t(`webhook_events.event${data.event_id}`) : null} />],
					[t('common.date'), <Placeholder value={response_date ? moment.unix(response_date).format('YYYY-MM-DD HH:mm') : null} width={50} />],
				]}
			/>
		</Groupper>
		{!!data && (
			<Groupper title={t('webhooks.data_sent')} style={{ marginTop: 15 }} width={600}>
				<ReactJson src={data?.response?.sent} displayDataTypes={false} name={false} />
				<Groupper.Divider text={t('webhooks.data_received').toUpperCase()} style={{ fontSize: 16, fontWeight: 'bold' }} />
				{data?.response?.response ? (
					<ReactJson src={data?.response?.response} displayDataTypes={false} name={false} />
				) : (
					<Header text={t('webhooks.no_response')} subtext={t('webhooks.no_response_description')} />
				)}
			</Groupper>
		)}
		<Modal open={shownModal===Modals.RESEND} onClose={bindClose(setShownModal)} size='tiny'>
			<Modal.Header text={t('webhooks.resend_webhook')} />
			<Modal.Content>
				<Header text={t('webhooks.resend_webhook')} subtext={t('webhooks.resend_webhook_description')} />
				<Table striped details
					title={t('common.webhook')}
					className='last'
					data={[
						['ID', <Placeholder value={data?.response_id} width={30} />],
						[t('common.webhook'), <Placeholder value={data?.webhook_id} />],
						['URL', <Placeholder value={data?.webhook_url} />],
						[t('common.event'), <Placeholder value={data?.event_id ? t(`webhook_events.event${data.event_id}`) : null} />],
					]}
				/>
				<Message list={modalPrompts} type='error' />
			</Modal.Content>
			<Modal.Actions>
				<Button text={t('common.close')} basic onClick={bindClose(setShownModal)} />
				<Button text={t('common.resend')} color='black' onClick={resendWebhook} />
			</Modal.Actions>
		</Modal>
	</div>
}

export default WebhookResponse;